import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../auth/services/auth.service';
import { HospitalStatus } from '@ics-referral-hub/shared-types';

@Component({
  selector: 'app-organization-inactive-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (showBanner()) {
      <div class="org-inactive-banner" role="status">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        <div class="banner-text">
          <strong>Your organization is inactive.</strong>
          You can review existing referrals and messages, but you cannot submit new
          referrals until ICS reactivates your organization.
          <a href="mailto:icssupport@bayshore.ca">Contact ICS support</a> if you need help.
        </div>
      </div>
    }
  `,
  styles: [
    `
      .org-inactive-banner {
        display: flex;
        gap: 12px;
        align-items: flex-start;
        padding: 12px 16px;
        margin: 0 0 16px;
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: 8px;
        color: #92400e;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        line-height: 1.5;
      }

      .org-inactive-banner i {
        color: #d97706;
        font-size: 1.25rem;
        margin-top: 2px;
      }

      .banner-text a {
        color: #1d4ed8;
        font-weight: 600;
        text-decoration: underline;
        margin-left: 4px;
      }
    `,
  ],
})
export class OrganizationInactiveBannerComponent {
  private readonly authService = inject(AuthService);

  readonly showBanner = computed(() => {
    const status = this.authService.organizationHospitalStatus();
    return (
      status === HospitalStatus.INACTIVE || status === HospitalStatus.PENDING
    );
  });
}
